import * as React from "react";
const SvgFiRrFeedbackHand = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-feedback-hand_svg__a)">
      <path
        fill="#062147"
        d="M24 5v2c0 2.757-2.243 5-5 5h-2a1 1 0 0 1 0-2h2c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2c0 1.654 1.346 3 3 3a1 1 0 0 1 0 2c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-5.238 13.552-4.755-1.783v-4.662c0-1.516-1.076-2.834-2.503-3.066a3.01 3.01 0 0 0-2.439.674 3 3 0 0 0-1.057 2.286v7.563l-1.003-.799a3 3 0 0 0-4.058 4.416l.558.538c.186.18.435.28.694.28.9 0 1.342-1.095.694-1.72l-.568-.548a1.001 1.001 0 0 1 1.364-1.464c.011.011 1.771 1.415 1.771 1.415a1.56 1.56 0 0 0 1.66.186c.548-.264.889-.806.889-1.415v-8.455c0-.294.128-.572.353-.762.228-.193.519-.272.823-.224.462.076.825.556.825 1.093v5.354c0 .417.259.79.649.937l5.404 2.027a3 3 0 0 1 1.941 2.633 1 1 0 0 0 .998.942l.059-.001a1 1 0 0 0 .94-1.057 5 5 0 0 0-3.236-4.39zm2.207-13.23a.5.5 0 0 0-.47-.329h-1.5l-.531-1.49a.5.5 0 0 0-.938 0l-.531 1.49h-1.5a.499.499 0 0 0-.323.881l1.189.967-.47 1.508a.5.5 0 0 0 .755.566l1.354-.906 1.377.897a.5.5 0 0 0 .747-.576l-.489-1.49 1.183-.964a.5.5 0 0 0 .147-.554m-6 0a.5.5 0 0 0-.47-.329h-1.5l-.531-1.49a.5.5 0 0 0-.938 0l-.531 1.49h-1.5a.499.499 0 0 0-.323.881l1.446 1.142q.597-.048 1.202.05c.823.134 1.576.48 2.21.978l-.396-1.205 1.183-.964a.5.5 0 0 0 .148-.553M4.071 8.9a.5.5 0 0 0 .578.016l1.354-.906 1.377.897a.5.5 0 0 0 .747-.576l-.489-1.49 1.183-.964a.5.5 0 0 0-.322-.883h-1.5l-.531-1.49a.5.5 0 0 0-.938 0l-.531 1.49h-1.5a.499.499 0 0 0-.323.881l1.189.967-.47 1.508a.5.5 0 0 0 .176.55"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-feedback-hand_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeedbackHand;
